import { CheckProps } from "components/Atoms/SelectInputFilter/SelectInputFilterModel";

interface Tab {
  tabTitle: string;
  content: React.ReactNode;
  id: number;
  filtersType?: Filters;
}

export enum HeaderTabTypes {
  WhiteTheme,
  RedTheme,
}

export enum Filters {
  present,
  past,
}

export interface IProps {
  tabs: Tab[];
  onTabSelect: (selectedTabId: number) => void;
  selectedTabId?: number;
  type?: HeaderTabTypes;
  hasFilters?: boolean;
  filtersContent?: React.ReactNode;
  month?: number;
  year?: number;
  setYear?: React.Dispatch<React.SetStateAction<number>>;
  setMonth?: React.Dispatch<React.SetStateAction<number>>;
  checkedState?: CheckProps;
  setCheckedState?: React.Dispatch<React.SetStateAction<CheckProps>>;
}
